
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AboutHero from '@/components/about/AboutHero';
import TeamSection from '@/components/about/TeamSection';

const About = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>About Fordje — Our Team and Mission</title>
        <meta name="description" content="Meet the team behind Fordje. We're building the infrastructure layer for regulatory data across clean energy projects." />
        <link rel="canonical" href="https://www.fordje.com/about" />
        <meta property="og:title" content="About Fordje — Our Team and Mission" />
        <meta property="og:description" content="Meet the team behind Fordje. We're building the infrastructure layer for regulatory data across clean energy projects." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.fordje.com/about" />
        <meta property="og:image" content="https://www.fordje.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Fordje — Our Team and Mission" />
        <meta name="twitter:description" content="Meet the team behind Fordje. We're building the infrastructure layer for regulatory data across clean energy projects." />
        <meta name="twitter:image" content="https://www.fordje.com/og-image.png" />
      </Helmet>
      <Header variant="light" />
      <main className="overflow-hidden">
        <AboutHero />
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

export default About;
